import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root'
})
export class ParametrizacionesDeFactoresConversionService {

  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }

  obtener(): Observable<any[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.parametrizacionesDeFactoresConversion.obtenerTodo
    );
  }

  crear(request: any) {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.parametrizacionesDeFactoresConversion.crear,
      request
    );
  }

  editar(request: any) {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.parametrizacionesDeFactoresConversion.actualizar,
      request
    );
  }

  eliminar(id: number) {
    return this._commom.peticionDeleteConHeader(
      this.url + this.diccionarioModulo.url.parametrizacionesDeFactoresConversion.eliminar + id
    );
  }

  obtenerPorId(id: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.parametrizacionesDeFactoresConversion.obtenerPorId + id
    );
  }
}
